export default (story: string | null): boolean => {
  if (!story) {
    return false;
  }
  try {
    JSON.parse(story);
    return true;
  } catch {
    return false;
  }
};
